import classNames from 'classnames';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import ArrowLeftSVG from '@sharedSvg/palette_chevron_left.svg';
import ArrowRightSVG from '@sharedSvg/palette_chevron_right.svg';
import { Button } from 'palette/Button';
import { NAVIGATION_BUTTON_POSITION } from '@common/Search/constants/NavigationButtonPosition';

import '../styles/CarouselBanner.scss';

function CarouselBanner({ children, navigationButtonsPosition = NAVIGATION_BUTTON_POSITION.toTheSides, group }) {
    const [index, setIndex] = useState(0);

    const handleSwitch = (move, event) => {
        event.preventDefault();
        setIndex(index + move);
    };

    const currentPosition = {
        transform: navigationButtonsPosition
            ? `translateX(${index * -120}%)`
            : `translateX(${index * -100}%)`
    };
    const carouselSizeMobile = useMediaQuery({ minWidth: 1023 }) ? 5 : 3;
    const maxIndexValue = (Math.ceil(children.length / carouselSizeMobile) - 1);
    const navigationButtonsToSides = navigationButtonsPosition === NAVIGATION_BUTTON_POSITION.toTheSides;
    const navigationButtonsBellow = navigationButtonsPosition === NAVIGATION_BUTTON_POSITION.bellow;

    if (children.length === 0) {
        return null;
    }

    return (
        <div className={classNames('carousel-banner', { 'carousel-banner--button-below': navigationButtonsBellow })}>
            <div className="carousel-banner__display-wrapper">
                {
                    index !== 0 && navigationButtonsToSides && (
                        <button
                            className="carousel-banner__control-before"
                            onClick={event => handleSwitch(-1, event)}
                        >
                            <ArrowLeftSVG className="carousel-banner__control-svg" />
                        </button>
                    )
                }
                {
                    index < maxIndexValue && navigationButtonsToSides && (
                        <button
                            className="carousel-banner__control-after"
                            onClick={event => handleSwitch(1, event)}
                        >
                            <ArrowRightSVG className="carousel-banner__control-svg" />
                        </button>
                    )
                }
                <ul
                    className={classNames('carousel-banner__list',
                        { 'carousel-banner--button-below-list ': navigationButtonsBellow })}
                    data-products-group={group}
                    style={currentPosition}
                >
                    {
                        children
                    }
                </ul>
            </div>
            {
                navigationButtonsBellow && (
                    <>
                        <div className="carousel-banner__arrows-container">
                            <Button
                                isTransparent
                                disabled={index === 0}
                                theme="secondary"
                                onClick={event => handleSwitch(-1, event)}
                            >
                                <ArrowLeftSVG
                                    className="carousel-banner__control-svg"
                                />
                            </Button>
                            <Button
                                isTransparent
                                disabled={index !== 0}
                                theme="secondary"
                                onClick={event => handleSwitch(1, event)}
                            >
                                <ArrowRightSVG
                                    className="carousel-banner__control-svg"
                                />
                            </Button>
                        </div>
                        <div className="carousel-banner__horizontal-line-container">
                            <div className={classNames('carousel-banner__horizontal-line-left',
                                { 'carousel-banner__horizontal-line-left--active': index === 0 })}
                            />
                            <div className={classNames('carousel-banner__horizontal-line-right',
                                { 'carousel-banner__horizontal-line-right--active': index !== 0 })}
                            />
                        </div>
                    </>
                )
            }
        </div>
    );
}

export default CarouselBanner;
